import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DeductionListing, DeductionAddEdit } from './Pages';

export const DeductionRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DeductionListing} />
        <Route exact path={`${match.path}/AddEdit/:id?`} component={DeductionAddEdit} />
    </Fragment>
)